






























import { Record } from '@/types/Record';
import { mdiRecord, mdiRecordCircleOutline } from '@mdi/js';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'VideoInstruction',
    props: ['instruction', 'video', 'stream'],
    data(): {
        recordStartedTimestamp: number;
        mediaRecorder?: MediaRecorder;
        isRecording: boolean;
        recordData: Blob[];
        blob?: Blob | null;
        snackbar: boolean;
        snackbarMessage: string;
        snackbarColor: string;
        icons: {
            [key: string]: any;
        };
        file: any;
        objectUrl: string | null;
    } {
        return {
            recordStartedTimestamp: 0,
            isRecording: false,
            recordData: [],
            blob: null,
            snackbar: false,
            snackbarMessage: '',
            snackbarColor: 'error',
            icons: {
                record: mdiRecordCircleOutline,
                recording: mdiRecord,
            },
            file: null,
            objectUrl: null,
        };
    },
    computed: {
        ...mapGetters(['records']),
        record(): Record | undefined {
            return this.records.find((record: Record) => record.instruction_id === this.instruction.id && record.video_id === this.video.id);
        },
    },
    methods: {
        showSnackbarMessage(message: string) {
            this.snackbarMessage = message;
            this.snackbar = true;
        },
        start() {
            if (this.isRecording) {
                return;
            }

            this.isRecording = true;
            this.$emit('onstart');
            this.mediaRecorder?.start();
            this.recordStartedTimestamp = Date.now();
        },
        stop(): void {
            const duration = (Date.now() - this.recordStartedTimestamp) / 1000;

            if (duration < 1) {
                return;
            }

            if (duration < this.instruction.minlength ?? 0) {
                window.setTimeout(this.stop.bind(this), 100);

                return;
            }

            this.isRecording = false;
            this.$emit('onstop');
            this.mediaRecorder?.stop();
        },
        onFileChange(file: File) {
            this.file = file;
            this.objectUrl = URL.createObjectURL(file);
        },
        onLoadedMetaData() {
            const { duration } = this.$refs.video as HTMLVideoElement;

            if (this.instruction.minlength > duration) {
                this.file = null;

                return this.showSnackbarMessage('Video is too short.');
            }

            if (this.instruction.length < duration) {
                this.file = null;

                return this.showSnackbarMessage('Video is too long.');
            }

            this.submit();
        },
        async submit() {
            if (!this.blob && !this.file) {
                return;
            }

            const result = await this.$store.dispatch('uploadRecord', {
                value: this.blob ?? this.file,
                instruction: this.instruction,
                video: this.video,
            }) as Promise<boolean>;

            if (result) {
                this.$emit('next');
            }
        },
    },
    mounted(): void {
        this.mediaRecorder = new MediaRecorder(this.stream, {
            mimeType: 'video/webm',
        });

        this.mediaRecorder.ondataavailable = (event: BlobEvent) => {
            this.recordData.push(event.data);
        };

        this.mediaRecorder.onstop = async () => {
            this.file = null;
            this.blob = new Blob(this.recordData, {
                type: 'video/webm',
            });
            this.recordData = [];
            this.submit();
        };
    },
});
